module.exports = __webpack_public_path__ + "media/images/icons/play-86445fd39b3d1b4096b446644897555d.svg";